import React from 'react';
import '../FirstSlider/FirstSlider.css';
import './SecondSlider.css';
import OV1 from '../../Assets/ov1.png';
import OV2 from '../../Assets/ov2.png';
import OV3 from '../../Assets/ov3.png';
import OV4 from '../../Assets/ov4.png';
import OV5 from '../../Assets/ov5.png';
import OV6 from '../../Assets/ov6.png';
import OV7 from '../../Assets/ov7.png';
import OV8 from '../../Assets/ov8.png';
import OV9 from '../../Assets/ov9.png';
import OV10 from '../../Assets/ov10.png';
import OV11 from '../../Assets/ov11.png';
import OV12 from '../../Assets/ov12.png';
import OV13 from '../../Assets/ov13.png';
import OV14 from '../../Assets/ov14.png';



function SecondSlider() {
  return (
    <div className='Second_Slider'>
      <div className='Second_Slider_Head'>
        <h1>OUR VALUED CLIENTS</h1>
        <hr />
        <div className='First_Slider_Main'>
          <marquee scrollamount='10' direction="left">
            <img src={OV1} alt="" />
            <img src={OV2} alt="" />
            <img src={OV3} alt="" />
            <img src={OV4} alt="" />
            <img src={OV5} alt="" />
            <img src={OV6} alt="" />
            <img src={OV7} alt="" />
            <img src={OV8} alt="" />
            <img src={OV9} alt="" />
            <img src={OV10} alt="" />
            <img src={OV11} alt="" />
            <img src={OV12} alt="" />
            <img src={OV13} alt="" />
            <img src={OV14} alt="" />
          </marquee>
        </div>
      </div>
    </div>
  )
}

export default SecondSlider
